import { render } from "./PartenairePage.vue?vue&type=template&id=05cae352&scoped=true"
import script from "./PartenairePage.vue?vue&type=script&lang=js"
export * from "./PartenairePage.vue?vue&type=script&lang=js"

import "./PartenairePage.vue?vue&type=style&index=0&id=05cae352&scoped=true&lang=css"
import "./PartenairePage.vue?vue&type=style&index=1&id=05cae352&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cae352"]])

export default __exports__